import moment from "moment";
import { LoadState } from "../../constants/enums";

import {
  IServiceRequesitionState,
  IServiceRequesition,
  IServiceRequesitionItem,
} from "./service-request.types";
import { getUniqueId } from "../../helpers";

export const defaultServiceRequesitionItem: IServiceRequesitionItem = {
  service_requesition_item_uuid: getUniqueId(),
  description: "",
  price: 0,
};

export const defaultServiceRequesition: IServiceRequesition = {
  service_requesition_uuid: null,
  service_requesition_no: "",
  service_requesition_date: "YYYY-MM-DD",
  service_requesition_name: "",
  project_uuid: "",
  project_name: "",
  project_manager_uuid: "",
  project_manager_name: "",
  finance_manager_uuid: "",
  finance_manager_name: "",
  vendor_uuid: null,
  vendor_name: null,
  priority: null,
  additional_fields: [],
  sr_items: [defaultServiceRequesitionItem],
  attachment: [],
  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  status: "DRAFT",
  total: 0,
  term_and_conditions: "",
  payment_terms: "",
  addtional_clauses_or_conditions: "",
};
export const defaultServiceRequesitionState: IServiceRequesitionState = {
  service_requisition_list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  single_service_requisition: {
    data: defaultServiceRequesition,
    loading: LoadState.NotLoaded,
    error: null,
  },
  service_requisition_approval_list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
